import { render, staticRenderFns } from "./LiveConsole.vue?vue&type=template&id=a5bc3960&scoped=true&"
import script from "./LiveConsole.vue?vue&type=script&lang=js&"
export * from "./LiveConsole.vue?vue&type=script&lang=js&"
import style0 from "./LiveConsole.vue?vue&type=style&index=0&id=a5bc3960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bc3960",
  null
  
)

export default component.exports